export const MAX_WIDTH = 450
export const MIN_WIDTH = 320
const REM_RATIO = 10
const RESIZE_DELAY = 400
const HANDHELD_UA = /mobile|iphone|ipad|ipod|android|phone|tablet/i

let started = false
let delayTimer = null
let onLayout = null
let screenCssWidth = 0
let screenWidthSnapshot = 0
let expectedInner = 0
let ignoreInnerUntil = 0

export function isHandheld() {
  if (typeof window === 'undefined') {
    return false
  }
  const hoverNone = window.matchMedia && window.matchMedia('(hover: none)').matches
  const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches
  if (hoverNone || coarse) {
    return true
  }
  return typeof navigator !== 'undefined' && HANDHELD_UA.test(navigator.userAgent || '')
}

/**
 * 键鼠桌面才走桌面壳。触屏设备不看系统，展开超过 768 也按折叠屏适配。
 */
export function isDesktopShell() {
  if (typeof window === 'undefined' || isHandheld()) {
    return false
  }
  return window.innerWidth >= 768
}

function setFontSize() {
  const { clientWidth } = document.documentElement
  let clampedWidth = 0

  if (clientWidth > MAX_WIDTH) {
    clampedWidth = MAX_WIDTH
  } else if (clientWidth < MIN_WIDTH) {
    clampedWidth = MIN_WIDTH
  }

  if (!clampedWidth) {
    document.documentElement.style.fontSize = ''
    return
  }

  document.documentElement.style.fontSize = clampedWidth / REM_RATIO + 'px'
}

function scheduleFontSize() {
  if (delayTimer) {
    clearTimeout(delayTimer)
  }
  delayTimer = setTimeout(() => {
    setFontSize()
    if (onLayout) {
      onLayout()
    }
    delayTimer = null
  }, RESIZE_DELAY)
}

function onWindowResize() {
  if (onLayout) {
    onLayout()
  }
  if (!delayTimer) {
    setFontSize()
  }
  scheduleFontSize()
}

function resizeHtmlDelay() {
  setFontSize()
  if (onLayout) {
    onLayout()
  }
  scheduleFontSize()
}

/**
 * 记录改写 viewport 后预期的 innerWidth，避免把它当成折叠展开。
 */
export function lockViewportRead(nextInner) {
  expectedInner = nextInner || 0
  ignoreInnerUntil = Date.now() + 500
}

/**
 * 折叠展开前的 CSS 宽度。viewport meta 会改 innerWidth，screen.width 变化才按比例更新。
 */
export function readScreenCssWidth() {
  const inner = window.innerWidth || document.documentElement.clientWidth || MIN_WIDTH
  const screenWidth = (window.screen && window.screen.width) || 0
  if (!screenCssWidth) {
    screenCssWidth = inner
    screenWidthSnapshot = screenWidth
    return screenCssWidth
  }
  if (screenWidth && screenWidthSnapshot && screenWidth !== screenWidthSnapshot) {
    screenCssWidth = Math.max(MIN_WIDTH, Math.round(screenCssWidth * screenWidth / screenWidthSnapshot))
    screenWidthSnapshot = screenWidth
    return screenCssWidth
  }
  const ownViewportChange = expectedInner && Math.abs(inner - expectedInner) < 40
  if (Date.now() < ignoreInnerUntil || ownViewportChange) {
    return screenCssWidth
  }
  if (Math.abs(inner - screenCssWidth) > 80) {
    screenCssWidth = inner
  }
  return screenCssWidth
}

/**
 * 按 320~450 限制 html font-size，避免 rem 被撑大。
 * layout 在折叠展开后重算视口。
 */
export function initResize(layout) {
  if (typeof layout === 'function') {
    onLayout = layout
  }
  if (started || typeof window === 'undefined') {
    return
  }

  started = true
  window.addEventListener('resize', onWindowResize)
  window.addEventListener('pageshow', resizeHtmlDelay)
  window.addEventListener('load', resizeHtmlDelay)
  // 立即设一次，再延迟设一次，避免宽度未就绪时不生效
  resizeHtmlDelay()
}
